// extracted by mini-css-extract-plugin
export default {"container":"Courses_container__pdI1i","course-item":"Courses_course-item__U43+T"};